module.exports = __webpack_public_path__ + "static/img/uncommon.d2d0fc72.png";